import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Lottie from 'lottie-react';
import warningAnimation from '../../../assets/json/warning.json';
import Button from '@mui/material/Button';
import TableComp from '../../LoanApplicationsPage/LoanApplicationsDashboard/OtherLoanApplicationStages/componenets/StaticPages/EligibilityCheck/CamTab/TableComp';
import CloseIcon from '@mui/icons-material/Close';
import {red} from '@mui/material/colors';
import './partialUploadModal.css';

const PartialUploadModal = ({
  isOpen,
  onClose,
  failedRecords = [],
  totalRecordCount = 0,
}) => {
  const failedCount = failedRecords.length;
  const successCount = totalRecordCount - failedCount;

  const loanColumns = [
    {label: 'Row Details', field: 'record', align: 'left'},
    {label: 'Status', field: 'partnerName', align: 'right'},
  ];

  const rows = failedRecords.map(row => ({
    record: row.record || (typeof row === 'string' ? row : JSON.stringify(row)),
    partnerName: <CloseIcon sx={{color: red[500], fontSize: 20}} />,
  }));

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '20px',
          textAlign: 'center',
        },
      }}>
      <Box className="upload-modal-container">
        <Box className="upload-modal-animation">
          <Lottie animationData={warningAnimation} loop={false} />
        </Box>
        <Box className="upload-modal-title">Partial Upload Done</Box>
        {failedCount > 0 && (
          <Box className="upload-modal-text">
            {successCount}/{totalRecordCount} records have been uploaded
            successfully. The following {failedCount} records encountered errors
            during the upload process.
          </Box>
        )}
        <Box className="upload-modal-table">
          {failedCount > 0 ? (
            <TableComp
              columns={loanColumns}
              rows={rows}
              showTotal={false}
              firstColumnBgColor="white"
            />
          ) : (
            <Box className="upload-modal-no-fail">No failed records found.</Box>
          )}
        </Box>
        <Button
          onClick={onClose}
          variant="outlined"
          className="upload-modal-close-button">
          Close
        </Button>
      </Box>
    </Dialog>
  );
};

PartialUploadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  failedRecords: PropTypes.array,
  totalRecordCount: PropTypes.number,
};

export default PartialUploadModal;
